import { Component, OnInit } from '@angular/core';
import { DialogConfig } from '../dialog-config';
import { DialogRef } from '../dialog-ref';
import { CommonModule } from '@angular/common';

export interface ConfirmDialogData {
  title?: string;
  message?: string;
  type?: 'timeout' | 'network' | 'server' | 'request';
  showRetry?: boolean;
  firstButton?: string;
  secondButton?: string;
  showCancel?: boolean;
}
@Component({
  standalone: true,
  selector: 'app-confirm',
  imports: [CommonModule],
  templateUrl: './confirm.component.html',
  styleUrls: ['./confirm.component.css']
})
export class ConfirmComponent implements OnInit {


  constructor(public config: DialogConfig, public dialog: DialogRef) { }

  ngOnInit(): void {
  }
  get data(): ConfirmDialogData {
    return this.config?.data || {};
  }
  get iconClass(): string {
    switch (this.data.type) {
      case 'timeout':
        return 'fa-solid fa-clock'; 
      case 'network':
        return 'fa-solid fa-wifi';  
      case 'server':
        return 'fa-solid fa-server'; 
      case 'request':
        return 'fa-solid fa-exclamation'; 
      default:
        return 'fa-solid fa-triangle-exclamation';
    }
  }

  // Bestämmer bakgrundsfärg för cirkeln runt ikonen
  get iconBgClass(): string {
    switch (this.data.type) {
      case 'timeout':
        return 'bg-timeout';
      case 'network':
        return 'bg-network';
      case 'server':
        return 'bg-server';
      case 'request':
        return 'bg-request';
      default:
        return 'bg-network';
    }
  }
  onAccept() {
    this.dialog.close(true);
  }
  onClose() {
    this.dialog.close(false);
  }
  onRetry() {
    this.dialog.close(true);
  }
}
